import { useEffect, useState, useRef } from "react";
import { Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
// import { Flag } from "semantic-ui-react";

// type LanguageOption = {
//   value: string;
//   label: JSX.Element;
// };

const MobileMenuHome = (logo: any) => {
  const [activeMenu, setActiveMenu] = useState("");
  const [isClicked, setIsclicked] = useState(false);
  
  // Create a reference to the navigation element
  const menuRef = useRef<HTMLDivElement>(null);

  const activeMenuSet = (value: any) =>
    setActiveMenu(activeMenu === value ? "" : value);

  const activeLi = (value: any) =>
    value === activeMenu ? { display: "block" } : { display: "none" };

  const { t } = useTranslation();

  // Handle clicking outside of the menu
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // If the menu is open and the click target is NOT inside the menuRef, close it
      if (isClicked && menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsclicked(false);
      }
    };

    // Bind the global click listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the listener on cleanup
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isClicked]);

  return (
    <nav 
      ref={menuRef} // Attach reference here
      className="main-menu navbar-expand-lg d-block d-lg-none mobile-header"
    >
      <Accordion>
        <div className="navbar-header">
          <div className="mobile-logo my-15">
            <Link to="/" onClick={() => setIsclicked(false)}>
              <img
                src={"/assets/tth_logo.png"}
                alt="Logo"
                style={{ height: "35px", width: "auto" }}
              />
            </Link>
          </div>

          {/* Toggle Button: Toggles the state between open and closed */}
          <div className="menu-sidebar d-block d-lg-none">
            <button onClick={() => setIsclicked(!isClicked)}>
              <span className="icon-bar" />
              <span className="icon-bar" />
              <span className="icon-bar" />
            </button>
          </div>
        </div>

        <Accordion.Collapse
          eventKey="nav"
          className="navbar-collapse clearfix"
          style={{ display: `${isClicked ? "block" : "none"}` }}
        >
          <ul className="navigation clearfix">
            <li>
              <Link to="/" onClick={() => setIsclicked(false)}>{t("navHome")}</Link>
            </li>
            <li className="dropdown">
              <Link to="#" onClick={(e) => e.preventDefault()}>{t("navServices")}</Link>
              <ul style={activeLi("services")}>
                <li><Link to="/web-development" onClick={() => setIsclicked(false)}>{t("navServicesSub1")}</Link></li>
                <li><Link to="/mobile-app-development" onClick={() => setIsclicked(false)}>{t("navServicesSub2")}</Link></li>
                <li><Link to="/software-development" onClick={() => setIsclicked(false)}>{t("navServicesSub3")}</Link></li>
                <li><Link to="/dev-ops" onClick={() => setIsclicked(false)}>{t("navServicesSub4")}</Link></li>
                <li><Link to="/cloud-computing" onClick={() => setIsclicked(false)}>{t("navServicesSub5")}</Link></li>
                <li><Link to="/digital-marketing" onClick={() => setIsclicked(false)}>{t("navServicesSub6")}</Link></li>
              </ul>
              <div className="dropdown-btn" onClick={() => activeMenuSet("services")}>
                <span className="fas fa-chevron-down" />
              </div>
            </li>
<li className="dropdown">
  <Link to="#" onClick={(e) => e.preventDefault()}>Solutions</Link>
  <ul style={activeLi("solutions")}>
    <li><Link to="/projects" onClick={() => setIsclicked(false)}>Projects</Link></li>
    <li><Link to="/cloud-adoption" onClick={() => setIsclicked(false)}>Cloud Adoption</Link></li>
    <li><Link to="/process-integration" onClick={() => setIsclicked(false)}>Process Integration</Link></li>
    <li><Link to="/manufacturing-execution" onClick={() => setIsclicked(false)}>Manufacturing Execution</Link></li>
    <li><Link to="/industrial-iot" onClick={() => setIsclicked(false)}>Industrial IoT</Link></li>
    <li><Link to="/systems-of-engagement" onClick={() => setIsclicked(false)}>Systems of Engagement</Link></li>
    <li><Link to="/customer-experience" onClick={() => setIsclicked(false)}>Customer Experience</Link></li>
  </ul>
  <div className="dropdown-btn" onClick={() => activeMenuSet("solutions")}>
    <span className="fas fa-chevron-down" />
  </div>
</li>
            <li><Link to="/about-us" onClick={() => setIsclicked(false)}>{t("navAbout")}</Link></li>
            <li><Link to="/press-release" onClick={() => setIsclicked(false)}>Press-Release</Link></li>
           <li className="dropdown">
  <Link to="#" onClick={(e) => e.preventDefault()}>Blogs</Link>
  <ul style={activeLi("blogs")}>
    <li><Link to="/blogs" onClick={() => setIsclicked(false)}>Blog</Link></li>
    <li><Link to="/case-studies" onClick={() => setIsclicked(false)}>Case Studies</Link></li>
  </ul>
  <div className="dropdown-btn" onClick={() => activeMenuSet("blogs")}>
    <span className="fas fa-chevron-down" />
  </div>
</li>
            <li><Link to="/contact-us" onClick={() => setIsclicked(false)}>{t("navContact")}</Link></li>
          </ul>
        </Accordion.Collapse>
      </Accordion>
    </nav>
  );
};

export default MobileMenuHome;